export enum SessionErrorCode {
  DELETED_SESSION = 'DELETED_SESSION',
  SESSION_FULL = 'SESSION_FULL',
}

export type Session = {
  id: number;
  // actualEndTime: string | null;
  // actualStartTime: string | null;
  date: string;
  enrolledUsers: number;
  maxParticipants: number;
  // meetingDetails: { notifyMe: boolean };
  isEnroll: boolean;
  topic: Template;
  // templateId: number;
  // tutorId: number;
  tutor: Tutor;
  // categoryId: number;
  // deleted: boolean;
  // locationId: number | null;
  groupId?: number;
  gseLevelId: number;
};

// const exampleSession = {
//   "id": 31429,
//   "date": "2024-11-21T10:20:00.000Z",
//   "maxParticipants": 6,
//   "enrolledUsers": 1,
//   "gseLevelId": 5,
//   "groupId": null,
//   "topic": {
//       "id": 143,
//       "contentSensitivity": false,
//       "minGSE": 53,
//       "maxGSE": 58,
//       "title": "Exploring Adjectives: Adding Color to Language",
//       "description": "Adjectives are like the spices of language; they add flavor, depth, and color to our words. In this lesson, we'll dive into the wonderful world of adjectives, exploring what they are, how they work, and why they're essential for effective communication.\n\nKey Points:\nDefinition of Adjectives,\nTypes of Adjectives,\nDescriptive Adjectives,\nQuantitative Adjectives,\nDemonstrative Adjectives,\nPossessive Adjectives,\nPlacement of Adjectives"
//   },
//   "tutor": {
//       "firstName": "Emmy",
//       "lastName": "A",
//       "thumb": "https://d13hgauxz9vfrb.cloudfront.net/courses/tutoring/thumbnails/8f8d7790-7e0a-4333-ace3-818fe28c718d"
//   },
//   "isEnroll": false
// }

export type Template = {
  description: string;
  discipline: string;
  id: number;
  level?: string;
  project: string;
  title: string;
  minGSE: number;
  maxGSE: number;
};

export type User = {
  id: string;
  email?: string;
  name: string;
  picture?: string;
  difficultyLevel?: string;
  state: number;
  isPrivate?: boolean;
  isWizard?: boolean;
  wizardSessionsNum?: number;
  roles: {
    premium: boolean;
    liveTutoring?: boolean;
    premiumLiveTutoring?: boolean;
  };
  b2b: {
    companyId: number | null;
    companyName: string | null;
    groupId: number | null;
    groupName: string | null;
  };
};

export type Tutor = {
  active: boolean;
  bio: string | null;
  creationDate: string;
  deleted: boolean;
  email: string;
  firstName: string;
  gender: string | null;
  id: number;
  lastName: string;
  numOfFeedbacks: number | null;
  phone: string;
  rank: string | null;
  thumb: string;
  vendor?: string;
};

export type SurveyQuestion = {
  type: string;
  feedback: number | 0;
  comment: string;
};

export type FilterQuery = {
  filterLevel: number[];
  filterDate: string;
  filterTime: number[];
};

export type DailyNotification = {
  time: number;
  id: number;
};

export type NotifyMeNotification = {
  time: number;
  id: number;
  date: Date;
  tutor: string;
  title: string;
};

export type ItemIdWithExpiry = {
  id: number;
  expiry: number;
};

export type UserWeeklyStatus = {
  [key: string]: {
    attended: number;
    booked: number;
  };
};

// private group:
export enum Genders {
  MALE = 'Male',
  FEMALE = 'Female',
  OTHER = 'Other',
  NOTSAY = 'I prefer not to say',
}

export interface GSELevel {
  id: number;
  code: string;
  level: string;
  minGSE: number;
  maxGSE: number;
}

export interface Category {
  id: number;
  // code: string;
  category: string;
}

export interface ExclusionInterval {
  startDate: string;
  endDate: string;
}
export interface SchedulingInterval {
  start: string;
  end: string;
}
export interface SchedulingWindow {
  // key: 'MO' | 'TU' | 'WE' | 'TH' | 'FR' | 'SA' | 'SU';
  key: string;
  intervals: SchedulingInterval[] | [];
}
export interface Children {
  id: number;
  name: string;
  parentId?: number;
  weeklyLimit?: number;
  duration?: number; // in minutes
  classSize?: number;
  schedulingWindow?: SchedulingWindow[] | [];
  exclusionDates?: ExclusionInterval[] | null;
  margin?: number;
  maxNumberOfStudents?: number | null;
  contentSensitivity?: boolean;
  rootId?: number;
  gender?: Genders | string;
  companyId?: number | null;
  categories?: Category[];
  GSELevels?: GSELevel[] | null;
  locations?: Location[] | null;
}
